import $ from 'jquery';

function toggle () {
    const self = $(this);
    const name = self.data('toggle');
    $(`[data-trigger="${name}"]`).trigger('toggle');
}

const toggles = $('[data-toggle]');

toggles.on('click', toggle);
toggles.not('button').on('keypress', function (e) {
    if (e.key === 'Enter') toggle.call(this);
});

